<script>
import resources from './resources'
import {TheMask} from 'vue-the-mask'
import 'vue-date-pick/dist/vueDatePick.css'

export default {
  name: 'shedules',
  mixins: [resources],
  components: {
    TheMask
  }
}
</script>


<template lang="pug">
section.content.profile-page
  page
  loading(
    :active.sync="loading",
    :can-cancel="false",
    :is-full-page="fullPage",
    color="#7159c1"
  )
  .container-fluid

    .block-header
      .row.clearfix
        .col-lg-5.col-md-5.col-sm-12
          h2 Perfil
          ul.breadcrumb.padding-0
            li.breadcrumb-item
              a(href="index.html")
                i.zmdi.zmdi-home
            li.breadcrumb-item
              a(href="javascript:void(0);") {{ user.name }}
            li.breadcrumb-item.active Perfil
            
    .row.clearfix
      .col-lg-12.col-md-12
        .card
          .body.bg-dark.profile-header
            .row(style="min-height: 115px;")
              .col-lg-10.col-md-12
                #uploadAvatar.cursor-pointer
                  img.user_pic.rounded.img-raised(
                    v-if="user.image !== null",
                    :src="user.image",
                    alt="User",
                    style="width: 180px;"
                  )
                  img.user_pic.rounded.img-raised(
                    v-if="user.image === null",
                    src="/static/images/profile_av.jpeg",
                    alt="User",
                    style="width: 180px;"
                  )
                .row
                  f-avatar
                .detail
                  .u_name
                    h4
                      strong {{ user.name }}
                    span {{ getTypeUser() }}

              //-.col-lg-2.col-md-12.user_earnings
                h6 Total Earnings
          ul.nav.nav-tabs.profile_tab
            li.nav-item
              router-link.nav-link.cursor-pointer(
                :to="{ name: 'dweller.profile.overview.me' }"
              ) Visão Geral
            li.nav-item
              a.nav-link.cursor-pointer.active(data-toggle="tab") Agendamentos
            li.nav-item
              router-link.nav-link.cursor-pointer(
                :to="{ name: 'dweller.profile.me.me' }"
              ) Perfil
        .tab-content
          #schedule.tab-pane.page-calendar.active(role="tabpanel")
            .row
              .col-md-12.col-lg-8
                .card
                  .body
                    .col-md-12.col-lg-12
                      //- Nexts events
                      nexts
                        //- Afters schedules
                        //- afters.m-b-20
                        //- For all
                        //- forall
              .col-md-12.col-lg-8
                .card
                  .body
                    .form-group
                      v-input(
                        :status="$v.schedule.tower_id.$error ? 'error' : null"
                      )
                        f-select(
                          name="tower_id",
                          v-model="schedule.tower_id",
                          placeholder="Selecionar Torre",
                          :searchable="true",
                          :options="dwellerTowers",
                          label-by="number",
                          @selected="selectUnitsTower"
                        )
                    .form-group
                      v-input(
                        :status="$v.schedule.unit_id.$error ? 'error' : null"
                      )
                        f-select(
                          name="unit_id",
                          v-model="schedule.unit_id",
                          :searchable="true",
                          :multiple="false",
                          placeholder="Selecionar unidade",
                          :options="dwellerUnits",
                          label-by="number"
                        )
                    f-select(
                      v-if="schedule.unit_id"
                      name="common_areas",
                      placeholder="Selecione uma Area",
                      :searchable="true",
                      v-model="area_id",
                      :options="commonAreaOptions",
                      label-by="label",
                      @selected="setCommomAreaId"
                    )
                .col-md-12.col-lg-8
                .card(v-if="id_common_area")
                  .body
                    date-pick(
                      v-if="!isScheduled"
                      v-model="schedule.start_date"
                      :hasInputElement="false"
                      :isDateDisabled="isFutureDate"
                      :weekdays="weekdays"
                      :months="months"
                      @input="selectTimesCommomArea"
                    )
                    date-pick(
                      v-if="isScheduled"
                      v-model="schedule.start_date"
                      :hasInputElement="false"
                      :isDateDisabled="isFutureDateMoreOne"
                      :weekdays="weekdays"
                      @input="selectTimesCommomArea"
                    )
                    //- VueDatePicker(
                    //-   v-model="schedule.start_date", 
                    //-   inline,
                    //-   color="#7159c1",
                    //-   :locale="local",
                    //-   :minDate="minDt",
                    //-   @input="selectTimesCommomArea"
                    //- )
                .card(v-if="scheduleTimes.length >= 1")
                  .body
                    #demo
                      transition-group.div-slider(tag='div' :name="back? 'slideback' : 'slide'")
                        div(v-if='currentIndex === 0' key='1')
                          .card
                            button.btn.btn-primary.btn-sm(
                              v-for="time in scheduleTimes", 
                              @click.prevent="doSchedule(time)"
                            )
                              | {{time.time}}
                        div(v-if='currentIndex === 1' key='2')
                            .form-group
                              .form-line
                                v-input(
                                  :status="$v.schedule.event_name.$error ? 'error' : null"
                                )
                                  input.form-control(
                                    type="text",
                                    v-model="schedule.event_name",
                                    placeholder="Descrição do Evento"
                                  )
                            .form-group
                              button.btn.btn-round.btn-primary.m-t-15(
                                :class="{'col-sm-12': isMobiled}",
                                @click.prevent="doSaveSchedule"
                              )
                                | Confirmar Agendamento
                      button.btn.btn-primary.btn-icon.btn-icon-mini.btn-round.float-rigth(
                        @click='prev()'
                        v-if="currentIndex >= 1"
                      )
                        i.zmdi.zmdi-arrow-left
                .card(v-if="scheduleByDay")
                  .body
                    #demo
                      .form-group
                        .form-line
                          v-input(
                            :status="$v.schedule.event_name.$error ? 'error' : null"
                          )
                            input.form-control(
                              type="text",
                              v-model="schedule.event_name",
                              placeholder="Descrição do Evento"
                            )
                      .form-group(
                        v-if="dwellerGuestListOptions.length <= 0 && isShow"
                      )
                        button.btn.btn-primary.btn-round.waves-effect(
                          type="button",
                          @click.prevent="isShow = !isShow",
                          style="width: 100%;"
                        ) Criar Lista Convidados

                      .form-group(v-if="dwellerGuestListOptions.length >= 1")
                          f-select(
                            name="dweller_guest_list_id",
                            v-model="schedule.dweller_guest_list_id",
                            :searchable="true",
                            :multiple="false",
                            placeholder="Selecionar Lista Convidados",
                            :options="dwellerGuestListOptions",
                            label-by="name"
                          )
                      div(
                        v-if="dwellerGuestListOptions.length <= 0 && !charge_for_hours && !isShow",
                        key="2"
                      )
                        .row.clearfix
                          .col-lg-12.col-md-12
                            .form-group
                              input.form-control(
                                type="text",
                                placeholder="Nome da Lista",
                                v-model="guest.name"
                              )
                          .col-lg-12.col-md-12
                            button.btn.btn-raised.btn-primary.btn-round.waves-effect(
                              type="button",
                              @click.prevent="doSaveNameList",
                              style="width: 100%;"
                            ) Salvar

                      .form-group
                        button.btn.btn-round.btn-primary.m-t-15(
                          :class="{'col-sm-12': isMobiled}",
                          v-if="dwellerGuestListOptions.length >= 1"
                          @click.prevent="doSaveSchedule"
                        )
                          | Confirmar Agendamento

</template>
<style scoped>
.vdpArrow:before {
  content: "";
  width: 2.2em;
  height: 2.2em;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -1.1em 0 0 -1.1em;
  border-radius: 100%;
  transition: background-color .2s;
  background-color: #fff;
}
.vdpArrow:active:before {
  background-color: #fff;
}
.vdpHeader {
  position: relative;
  padding: 0 1em 2.5em;
  margin: -1em -1em -2.5em;
  text-align: center;
  background: #7159c1;
}
.vdpPeriodControl>button {
  font-size: 1.5em;
  padding: 1em .4em;
  display: inline-block;
  color: #fff;
}
.vdpHeadCellContent {
  font-size: 1.2em;
  font-weight: 400;
  color: #fff;
}
.vdpCell.disabled {
    opacity: 0.2;
}
.vdpArrowPrev:after {
    border-right-color:#7159c1;
}
.vdpArrowNext:after {
    border-left-color:#7159c1;
}

.vdpCell.selectable:hover .vdpCellContent,
.vdpCell.selected .vdpCellContent {
    background:#7159c1;
}

.vdpCell.today {
    color:#928f8f;
}

.vdpTimeUnit > input:hover,
.vdpTimeUnit > input:focus {
    border-bottom-color:#7159c1;
}
#demo {
  overflow: hidden;
}
.float-rigth {
  float: right;
}
.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}

.slideback-leave-active,
.slideback-enter-active {
  transition: 1s;
}
.slideback-enter {
  transform: translate(-100%, 0);
}
.slideback-leave-to {
  transform: translate(100%, 0);
}

.div-slider{
  overflow: hidden;
  position: relative;
  height: 300px;
  width: 100%;
}

.div-slider .card {
  position: absolute;
  height: 300px;
  width: 100%;
  background-color: #fff;
}

@media only screen and (max-width: 420px) {
  .fc-toolbar .fc-right {
    /* display: none */
    width: 100%;
  }
  .fc-prev-button {
    background: #eee;
    color: #424242;
    font-size: 14px;
    border-radius: 30px !important;
    padding: 5px 6px;
    height: auto;
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .fc-next-button {
    background: #eee;
    color: #424242;
    font-size: 14px;
    border-radius: 30px !important;
    padding: 5px 7px;
    height: auto;
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .fc .fc-toolbar .fc-today-button,
  .fc .fc-toolbar .fc-state-default {
    background: #eee;
    color: #424242;
    font-size: 14px;
    border-radius: 30px !important;
    padding: 5px 2px;
    height: auto;
    border: none;
    box-shadow: none;
  }
  .fc-toolbar .fc-left {
    width: 100%;
    margin-bottom: 15px;
  }
  .fc .fc-toolbar .fc-today-button {
    float: right;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fc .fc-view-container .fc-event {
  padding: 3px 5px;
  font-size: 12px;
  border-radius: 0.1875rem;
  background-color: #fff;
  border: 0;
  color: #fff;
}
.fc .fc-view-container .fc-event:hover {
  padding: 3px 5px;
  font-size: 12px;
  border-radius: 0.1875rem;
  background-color: #fff;
  border: 0;
  color: #fff;
}
/**datepicker */
.custom-button[data-v-651b7c9a] {
  padding: 0 20px;
  position: relative;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  height: 30px;
  font-size: 13px;
  outline: none;
  cursor: pointer;
  -webkit-transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  color: #fff;
  font-weight: 500;
}

.custom-button-content[data-v-651b7c9a] {
  position: relative;
}

.custom-button svg[data-v-651b7c9a] {
  position: relative;
  fill: #1e90ff;
}

.custom-button .custom-button-effect[data-v-651b7c9a],
.custom-button svg[data-v-651b7c9a] {
  -webkit-transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
}

.custom-button .custom-button-effect[data-v-651b7c9a] {
  position: absolute;
  background: #1e90ff;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 30px;
  border-radius: 4px;
  width: 100%;
  -webkit-transform: scale(0);
  transform: scale(0);
}

.custom-button.with-border[data-v-651b7c9a] {
  border: 1px solid #eaeaea;
}

.custom-button.is-hover[data-v-651b7c9a],
.custom-button[data-v-651b7c9a]:hover {
  border: 1px solid transparent !important;
}

.custom-button.is-hover .custom-button-effect[data-v-651b7c9a],
.custom-button:hover .custom-button-effect[data-v-651b7c9a] {
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 0.6;
}

.custom-button.is-hover svg[data-v-651b7c9a],
.custom-button:hover svg[data-v-651b7c9a] {
  fill: #fff !important;
}

.custom-button.is-hover .custom-button-content[data-v-651b7c9a],
.custom-button:hover .custom-button-content[data-v-651b7c9a] {
  color: #fff !important;
}

.custom-button.is-selected[data-v-651b7c9a] {
  border: 1px solid transparent !important;
}

.custom-button.is-selected .custom-button-effect[data-v-651b7c9a] {
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 1;
}

.custom-button.is-selected svg[data-v-651b7c9a] {
  fill: #fff !important;
}

.custom-button.is-selected .custom-button-content[data-v-651b7c9a] {
  color: #fff !important;
}

.custom-button.is-dark[data-v-651b7c9a] {
  background-color: #424242;
}

.custom-button.is-dark.with-border[data-v-651b7c9a] {
  border-color: #757575;
}

.custom-button.is-dark svg[data-v-651b7c9a] {
  fill: #fff !important;
}

.custom-button.round[data-v-651b7c9a] {
  padding: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.custom-button.round .custom-button-effect[data-v-651b7c9a] {
  border-radius: 50%;
  height: 24px;
}

.field[data-v-74507c40] {
  position: relative;
}

.field.is-dark .field-label[data-v-74507c40] {
  color: hsla(0, 0%, 100%, 0.7);
}

.field.is-dark .field-input[data-v-74507c40] {
  background-color: #424242;
  border-color: hsla(0, 0%, 100%, 0.7);
  color: hsla(0, 0%, 100%, 0.7);
}

.field.is-dark.is-disabled .field-input[data-v-74507c40],
.field.is-dark.is-disabled .field-label[data-v-74507c40] {
  color: #000;
}

.field-label[data-v-74507c40] {
  position: absolute;
  top: 5px;
  cursor: pointer;
  left: 13px;
  -webkit-transform: translateY(25%);
  transform: translateY(25%);
  opacity: 0;
  -webkit-transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
}

.field-input[data-v-74507c40] {
  cursor: pointer;
  background-color: #fff;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  position: relative;
  width: 100%;
  height: 42px;
  min-height: 42px;
  padding-left: 12px;
  padding-right: 44px;
  font-weight: 400;
  -webkit-appearance: none;
  outline: none;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 30px;
  font-size: 14px;
  z-index: 0;
}

.field-input.no-clear-button[data-v-74507c40] {
  padding: 0 12px;
}

.field-clear-button[data-v-74507c40] {
  position: absolute;
  right: 12px;
}

.field.has-error .field-input[data-v-74507c40] {
  border-color: #ff4500;
}

.field.has-error .field-label[data-v-74507c40] {
  opacity: 1;
  -webkit-transform: translateY(0);
  transform: translateY(0);
  font-size: 11px;
}

.field.has-error .field-input[data-v-74507c40] {
  padding-top: 14px;
}

.field.has-value .field-label[data-v-74507c40] {
  opacity: 1;
  -webkit-transform: translateY(0);
  transform: translateY(0);
  font-size: 11px;
}

.field.has-value:not(.no-label) .field-input[data-v-74507c40] {
  padding-top: 14px;
}

.field.is-focused .field-input[data-v-74507c40] {
  border-color: #1e90ff;
}

.field.is-focused .field-label[data-v-74507c40] {
  color: #1e90ff;
}

.field.is-disabled .field-input[data-v-74507c40] {
  border-color: #ccc;
  background: #f2f2f2;
}

.field.is-disabled .field-input[data-v-74507c40],
.field.is-disabled .field-label[data-v-74507c40] {
  cursor: default;
}

.field .text-danger[data-v-74507c40] {
  color: #ff4500;
}

.field.is-dark[data-v-74507c40] ::-webkit-input-placeholder {
  color: hsla(0, 0%, 100%, 0.7);
}

.field.is-dark[data-v-74507c40] :-moz-placeholder {
  color: hsla(0, 0%, 100%, 0.7);
  opacity: 1;
}

.field.is-dark[data-v-74507c40] :-ms-input-placeholder {
  color: hsla(0, 0%, 100%, 0.7);
}

.field.is-dark[data-v-74507c40] ::-ms-input-placeholder {
  color: hsla(0, 0%, 100%, 0.7);
}

.field.is-dark[data-v-74507c40] ::placeholder {
  color: hsla(0, 0%, 100%, 0.7);
}

.field.is-dark.is-disabled[data-v-74507c40] ::-webkit-input-placeholder {
  color: #424242;
}

.field.is-dark.is-disabled[data-v-74507c40] :-moz-placeholder {
  color: #424242;
  opacity: 1;
}

.field.is-dark.is-disabled[data-v-74507c40] :-ms-input-placeholder {
  color: #424242;
}

.field.is-dark.is-disabled[data-v-74507c40] ::-ms-input-placeholder {
  color: #424242;
}

.field.is-dark.is-disabled[data-v-74507c40] ::placeholder {
  color: #424242;
}

.field.sm .field-input[data-v-74507c40] {
  height: 36px;
  min-height: 36px;
  font-size: 12px;
}

.field.sm .field-label[data-v-74507c40] {
  font-size: 10px;
}

.field.sm.has-value:not(.no-label) .field-input[data-v-74507c40] {
  padding-top: 12px;
}

.field.lg .field-input[data-v-74507c40] {
  height: 48px;
  min-height: 48px;
  font-size: 16px;
}

.field.lg .field-label[data-v-74507c40] {
  font-size: 14px;
}

.field.lg.has-value:not(.no-label) .field-input[data-v-74507c40] {
  padding-top: 16px;
}

.shortcuts-container[data-v-9b117170] {
  width: 140px;
  max-width: 140px;
  min-width: 140px;
  padding: 10px 5px;
  border-right: 1px solid #eaeaea;
  overflow: auto;
}

.shortcuts-container button.shortcut-button[data-v-9b117170] {
  margin-bottom: 10px;
  width: 100%;
}

.shortcuts-container.is-dark[data-v-9b117170] {
  border-color: #757575;
}

@media screen and (max-width: 415px) {
  .shortcuts-container[data-v-9b117170]:not(.inline) {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    max-width: 100vw;
    min-width: 100vw;
    border-right: 0;
    border-bottom: 1px solid #eaeaea;
    height: 52px !important;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    white-space: nowrap;
  }
  .shortcuts-container:not(.inline) .shortcut-button[data-v-9b117170] {
    margin-bottom: 0;
  }
  .shortcuts-container:not(.inline)
    .shortcut-button[data-v-9b117170]:not(:last-child) {
    margin-right: 10px;
  }
  .shortcuts-container.is-dark[data-v-9b117170] {
    border-color: #757575;
  }
}

.year-month-selector[data-v-4a0f7afa] {
  position: absolute;
  background-color: #fff;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: #424242;
  padding: 10px;
}

.year-month-selector.dark[data-v-4a0f7afa] {
  color: #fff;
  background-color: #424242;
}

.year-month-selector .month-button[data-v-4a0f7afa] {
  text-transform: capitalize;
}

.week-days[data-v-a5a27e8c] {
  height: 41px;
  text-transform: capitalize;
}

.week-days.is-dark .week-days-container[data-v-a5a27e8c] {
  color: #a8a8a8 !important;
}

@media screen and (max-width: 415px) {
  :not(.inline) .datepicker-week[data-v-a5a27e8c] {
    height: 21px !important;
  }
}

.datepicker-container[data-v-628b1b6b] {
  width: 260px;
  padding: 0 5px;
  position: relative;
}

.datepicker-container.range.has-shortcuts[data-v-628b1b6b] {
  width: 400px;
}

.datepicker-container.p-0[data-v-628b1b6b] {
  padding: 0;
}

.datepicker-container .padding-button[data-v-628b1b6b] {
  padding: 5px 3px !important;
}

.datepicker-container .calendar[data-v-628b1b6b] {
  position: relative;
}

.datepicker-container .datepicker-controls[data-v-628b1b6b] {
  height: 56px;
}

.datepicker-container .datepicker-controls .arrow-month[data-v-628b1b6b] {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 40px;
  flex: 0 0 40px;
}

.datepicker-container .datepicker-controls .datepicker-button[data-v-628b1b6b] {
  background: transparent;
  cursor: pointer;
  padding: 0 10px;
  border: none;
  outline: none;
}

.datepicker-container
  .datepicker-controls
  .datepicker-button
  svg[data-v-628b1b6b] {
  height: 17px;
  width: 17px;
  fill: #2c3e50;
}

.datepicker-container
  .datepicker-controls
  .datepicker-button.datepicker-prev[data-v-628b1b6b] {
  text-align: left !important;
}

.datepicker-container
  .datepicker-controls
  .datepicker-button.datepicker-next[data-v-628b1b6b] {
  text-align: right !important;
}

.datepicker-container
  .datepicker-controls
  .datepicker-container-label[data-v-628b1b6b] {
  text-transform: capitalize;
  font-size: 16px;
  position: relative;
  height: 56px;
  overflow: hidden;
}

.datepicker-container .datepicker-controls .date-buttons[data-v-628b1b6b] {
  text-transform: capitalize;
  font-weight: 400;
}

.datepicker-container .month-container[data-v-628b1b6b] {
  position: relative;
  overflow: hidden;
}

.datepicker-container .datepicker-days[data-v-628b1b6b] {
  display: -webkit-box;
  display: flex;
  display: -ms-flexbox;
  overflow: hidden;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
}

.datepicker-container .datepicker-days .datepicker-day[data-v-628b1b6b] {
  height: 41px;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  width: 14.28571%;
  position: relative;
  border: none;
  background: transparent;
  font-size: 13px;
  outline: none;
}

.datepicker-container .datepicker-days .datepicker-day.enable[data-v-628b1b6b] {
  cursor: pointer;
}

.datepicker-container .datepicker-days .datepicker-day-effect[data-v-628b1b6b],
.datepicker-container
  .datepicker-days
  .datepicker-day
  .datepicker-today[data-v-628b1b6b] {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 30px;
  width: 30px;
  border-radius: 4px;
  -webkit-transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
}

.datepicker-container
  .datepicker-days
  .datepicker-day
  .datepicker-day-effect[data-v-628b1b6b] {
  margin: auto;
  opacity: 0.6;
  background: #1e90ff;
  -webkit-transform: scale(0);
  transform: scale(0);
}

.datepicker-container
  .datepicker-days
  .datepicker-day
  .datepicker-today[data-v-628b1b6b] {
  background-color: #eaeaea;
}

.datepicker-container
  .datepicker-days
  .datepicker-day
  .datepicker-day-text[data-v-628b1b6b] {
  position: relative;
  color: #000;
}

.datepicker-container
  .datepicker-days
  .datepicker-day
  .datepicker-day-keyboard-selected[data-v-628b1b6b] {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 26px;
  width: 26px;
  opacity: 0.7;
  border-radius: 50%;
  -webkit-transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  background-color: #afafaf;
}

.datepicker-container
  .datepicker-days
  .datepicker-day:hover
  .datepicker-day-text[data-v-628b1b6b] {
  color: #fff;
}

.datepicker-container
  .datepicker-days
  .datepicker-day:hover
  .datepicker-day-effect[data-v-628b1b6b] {
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 0.6;
}

.datepicker-container
  .datepicker-days
  .datepicker-day.between
  .datepicker-day-text[data-v-628b1b6b] {
  color: #fff;
}

.datepicker-container
  .datepicker-days
  .datepicker-day.between
  .datepicker-day-effect[data-v-628b1b6b] {
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 0.5;
  border-radius: 0;
  width: 100%;
}

.datepicker-container
  .datepicker-days
  .datepicker-day.between.first
  .datepicker-day-effect[data-v-628b1b6b] {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.datepicker-container
  .datepicker-days
  .datepicker-day.between.last
  .datepicker-day-effect[data-v-628b1b6b] {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.datepicker-container
  .datepicker-days
  .datepicker-day.between
  .datepicker-day-keyboard-selected[data-v-628b1b6b],
.datepicker-container
  .datepicker-days
  .datepicker-day.between.first
  .datepicker-day-keyboard-selected[data-v-628b1b6b],
.datepicker-container
  .datepicker-days
  .datepicker-day.between.last
  .datepicker-day-keyboard-selected[data-v-628b1b6b] {
  background-color: rgba(0, 0, 0, 0.66);
}

.datepicker-container
  .datepicker-days
  .datepicker-day.selected
  .datepicker-day-text[data-v-628b1b6b] {
  color: #fff;
  font-weight: 700;
}

.datepicker-container
  .datepicker-days
  .datepicker-day.selected
  .datepicker-day-effect[data-v-628b1b6b] {
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 1;
}

.datepicker-container
  .datepicker-days
  .datepicker-day.selected
  .datepicker-day-keyboard-selected[data-v-628b1b6b] {
  background-color: rgba(0, 0, 0, 0.66);
}

.datepicker-container
  .datepicker-days
  .datepicker-day.disabled
  .datepicker-day-text[data-v-628b1b6b] {
  color: #ccc;
}

.datepicker-container
  .datepicker-days
  .datepicker-day.disabled.selected[data-v-628b1b6b] {
  color: #fff;
}

.datepicker-container
  .datepicker-days
  .datepicker-day.disabled
  .datepicker-day-effect[data-v-628b1b6b] {
  -webkit-transform: scale(0);
  transform: scale(0);
  opacity: 0;
}

.datepicker-container.is-dark
  .datepicker-days
  .datepicker-day:not(.between):not(.selected)
  .datepicker-day-text[data-v-628b1b6b] {
  color: #fff;
}

.datepicker-container.is-dark
  .datepicker-days
  .datepicker-day:not(.between):not(.selected).disabled
  .datepicker-day-text[data-v-628b1b6b] {
  color: #757575;
}

.datepicker-container.is-dark .datepicker-label[data-v-628b1b6b] {
  color: #fff;
}

.datepicker-container.is-dark .text-muted[data-v-628b1b6b] {
  color: #a8a8a8 !important;
}

.datepicker-container.is-dark .datepicker-button svg[data-v-628b1b6b] {
  fill: #fff;
}

.datepicker-container.is-dark .datepicker-today[data-v-628b1b6b] {
  background-color: #292929 !important;
}

@media screen and (max-width: 415px) {
  .fc-toolbar .fc-right {
    /* display: none */
    width: 269px;
  }
  .fc .fc-toolbar h2 {
    font-size: 10px;
    text-transform: uppercase;
  }
  .fc-prev-button {
    background: #eee;
    color: #424242;
    font-size: 14px;
    border-radius: 30px !important;
    padding: 5px 6px;
    height: auto;
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .fc-next-button {
    background: #eee;
    color: #424242;
    font-size: 14px;
    border-radius: 30px !important;
    padding: 5px 7px;
    height: auto;
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    float: right;
  }
  .fc .fc-toolbar .fc-today-button,
  .fc .fc-toolbar .fc-state-default {
    background: #eee;
    color: #424242;
    font-size: 14px;
    border-radius: 30px !important;
    padding: 5px 2px;
    height: auto;
    border: none;
    box-shadow: none;
    float: none;
  }
  .datepicker-container[data-v-628b1b6b] {
    width: 100%;
    -ms-flex-direction: column;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    -ms-flex-flow: column;
    flex-flow: column;
    -moz-flex-direction: column;
  }
  .datepicker-container:not(.inline) .datepicker-controls[data-v-628b1b6b] {
    height: 36px !important;
  }
  .datepicker-container.range.has-shortcuts[data-v-628b1b6b] {
    width: 100%;
  }
}

.time-picker-column[data-v-683a4ef0]::-webkit-scrollbar {
  display: none;
}

.time-picker[data-v-683a4ef0] {
  width: 160px;
  max-width: 160px;
  position: relative;
  z-index: 1;
}

.time-picker.inline[data-v-683a4ef0] {
  width: 100%;
  max-width: 100%;
}

.time-picker[data-v-683a4ef0]:after,
.time-picker[data-v-683a4ef0]:before {
  content: "";
  top: 50%;
  position: absolute;
  margin: 0 auto;
  margin-top: -14px;
  height: 30px;
  z-index: -1;
  width: 85%;
  left: 0;
  right: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: left;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.time-picker-column[data-v-683a4ef0] {
  position: relative;
  overflow-y: auto;
}

.time-picker-column-item[data-v-683a4ef0] {
  height: 28px;
  min-height: 28px;
  padding: 0;
  color: #252525;
  cursor: pointer;
  position: relative;
  border: none;
  background: transparent;
  font-size: 13px;
  width: 100%;
  outline: none;
}

.time-picker-column-item-effect[data-v-683a4ef0] {
  position: absolute;
  opacity: 0.6;
  background: #1e90ff;
  height: 24px;
  width: 70%;
  top: 2px;
  left: 15%;
  -webkit-transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  -webkit-transform: scale(0);
  transform: scale(0);
  border-radius: 4px;
}

.time-picker-column-item-effect[data-v-683a4ef0]:hover {
  -webkit-transform: scale(1);
  transform: scale(1);
}

.time-picker-column-item-text[data-v-683a4ef0] {
  position: relative;
}

.time-picker-column-item:hover .time-picker-column-item-text[data-v-683a4ef0] {
  color: #fff;
  -webkit-transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
}

.time-picker-column-item:hover
  .time-picker-column-item-effect[data-v-683a4ef0] {
  -webkit-transform: scale(1);
  transform: scale(1);
}

.time-picker-column-item.active[data-v-683a4ef0] {
  color: #fff;
  font-weight: 700;
}

.time-picker-column-item.active
  .time-picker-column-item-effect[data-v-683a4ef0] {
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 1;
}

.time-picker-column-item.disabled
  .time-picker-column-item-text[data-v-683a4ef0] {
  color: #ccc;
}

.time-picker-column-item.disabled
  .time-picker-column-item-text[data-v-683a4ef0]:hover {
  color: #ccc !important;
}

.time-picker-column-item.disabled
  .time-picker-column-item-effect[data-v-683a4ef0] {
  -webkit-transform: scale(0) !important;
  transform: scale(0) !important;
  opacity: 0 !important;
}

.time-picker-column-item.disabled.active
  .time-picker-column-item-effect[data-v-683a4ef0] {
  background-color: #eaeaea !important;
  -webkit-transform: scale(1) !important;
  transform: scale(1) !important;
  opacity: 1 !important;
}

.time-picker.with-border[data-v-683a4ef0] {
  border-left: 1px solid #eaeaea;
}

.time-picker.with-border.is-dark[data-v-683a4ef0] {
  border-left: 1px solid #757575;
}

.time-picker.is-dark .time-picker-column-item-text[data-v-683a4ef0] {
  color: #fff;
}

@media screen and (max-width: 415px) {
  .time-picker.inline[data-v-683a4ef0] {
    -webkit-box-flex: 1;
    -ms-flex: auto;
    flex: auto;
    border-left: none;
  }
  .time-picker[data-v-683a4ef0]:not(.inline) {
    border: 0;
    border-top: 1px solid #eaeaea;
    width: 100%;
    max-width: 100%;
    height: unset !important;
    overflow: hidden;
  }
  .time-picker:not(.inline).dark[data-v-683a4ef0] {
    border-top: 1px solid #757575;
  }
  .timepicker-container.is-dark[data-v-683a4ef0] {
    border-color: #757575;
  }
}

.header-picker[data-v-6d49f11d] {
  background: #fff;
  border-bottom: 1px solid #eaeaea;
  color: #fff;
  position: relative;
}

.header-picker-year[data-v-6d49f11d] {
  opacity: 0.7;
  margin-bottom: 5px;
  font-size: 14px;
  line-height: 14px;
  position: relative;
  height: 14px;
}

.header-picker-date[data-v-6d49f11d],
.header-picker-hour[data-v-6d49f11d],
.header-picker-minute[data-v-6d49f11d],
.header-picker-range[data-v-6d49f11d],
.header-picker-time[data-v-6d49f11d] {
  font-size: 18px;
  line-height: 18px;
  position: relative;
  height: 18px;
}

.header-picker-date[data-v-6d49f11d] {
  text-transform: capitalize;
}

.header-picker-hour.twelve[data-v-6d49f11d] {
  min-width: 74px;
}

.header-picker .pl-10[data-v-6d49f11d] {
  padding-left: 10px;
}

.header-picker .time-number[data-v-6d49f11d] {
  width: 22px;
}

.header-picker.is-dark[data-v-6d49f11d] {
  border: 0;
  color: #fff !important;
}

.datepicker-buttons-container[data-v-601c6e79] {
  padding: 5px;
  border-top: 1px solid #eaeaea;
  background-color: #fff;
  z-index: 1;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}

.datepicker-buttons-container .datepicker-button[data-v-601c6e79] {
  padding: 0 20px;
  position: relative;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  height: 30px;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  -webkit-transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  color: #fff;
  font-weight: 500;
}

.datepicker-buttons-container .datepicker-button-content[data-v-601c6e79] {
  position: relative;
}

.datepicker-buttons-container .datepicker-button svg[data-v-601c6e79] {
  position: relative;
  -webkit-transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  fill: #00c853;
}

.datepicker-buttons-container
  .datepicker-button
  .datepicker-button-effect[data-v-601c6e79] {
  position: absolute;
  background: #00c853;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 30px;
  border-radius: 4px;
  width: 100%;
  -webkit-transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  -webkit-transform: scale(0);
  transform: scale(0);
}

.datepicker-buttons-container .datepicker-button[data-v-601c6e79]:hover {
  border: 1px solid transparent;
}

.datepicker-buttons-container
  .datepicker-button:hover
  .datepicker-button-effect[data-v-601c6e79] {
  -webkit-transform: scale(1);
  transform: scale(1);
}

.datepicker-buttons-container .datepicker-button:hover svg[data-v-601c6e79] {
  fill: #fff !important;
}

.datepicker-buttons-container
  .datepicker-button:hover
  .datepicker-button-content[data-v-601c6e79] {
  color: #fff !important;
}

.datepicker-buttons-container
  .datepicker-button.now.right-margin[data-v-601c6e79] {
  margin-right: 10px;
}

.datepicker-buttons-container
  .datepicker-button.now
  .datepicker-button-content[data-v-601c6e79] {
  color: #1e90ff;
}

.datepicker-buttons-container
  .datepicker-button.now
  .datepicker-button-effect[data-v-601c6e79] {
  background: #1e90ff;
}

.datepicker-buttons-container .datepicker-button.validate[data-v-601c6e79] {
  border: 1px solid #eaeaea;
}

.datepicker-buttons-container.is-dark .datepicker-button[data-v-601c6e79],
.datepicker-buttons-container.is-dark[data-v-601c6e79] {
  background-color: #424242;
}

.datepicker-buttons-container.is-dark
  .datepicker-button[data-v-601c6e79]:not(.now),
.datepicker-buttons-container.is-dark[data-v-601c6e79]:not(.now) {
  border-color: #757575;
}

.datepicker-buttons-container.is-dark .datepicker-button svg[data-v-601c6e79],
.datepicker-buttons-container.is-dark svg[data-v-601c6e79] {
  fill: #fff !important;
}

.datetimepicker[data-v-6e81f291] {
  position: absolute;
  z-index: 9;
  width: 100%;
}

.datetimepicker.visible[data-v-6e81f291] {
  z-index: 999;
}

.datetimepicker .datepicker[data-v-6e81f291] {
  position: absolute;
  z-index: 5;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  max-width: 400px;
}

.datetimepicker .datepicker .pickers-container[data-v-6e81f291] {
  background: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.datetimepicker .datepicker.right[data-v-6e81f291] {
  right: 0;
}

.datetimepicker.is-dark .datepicker[data-v-6e81f291],
.datetimepicker.is-dark .pickers-container[data-v-6e81f291] {
  background: #424242;
  border: 0;
}

.inline .datepicker[data-v-6e81f291],
.inline.datetimepicker[data-v-6e81f291] {
  position: relative;
}

.inline .datepicker[data-v-6e81f291] {
  margin-bottom: 0 !important;
  box-shadow: none;
  -webkit-box-shadow: none;
  width: 100%;
  max-width: 100%;
  background-color: #fff;
}

@media screen and (max-width: 415px) {
  .pickers-container[data-v-6e81f291] {
    -ms-flex-direction: column;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    -ms-flex-flow: column;
    flex-flow: column;
    -moz-flex-direction: column;
    height: 100%;
  }
  .datepicker-container[data-v-6e81f291] {
    width: 100%;
  }
  .datepicker-container.has-shortcuts[data-v-6e81f291] {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .datetimepicker[data-v-6e81f291]:not(.inline) {
    margin: 0 !important;
    position: absolute;
    top: 0 !important;
    bottom: 0;
    right: 0;
    left: 0;
  }
  .datetimepicker:not(.inline) .datepicker[data-v-6e81f291] {
    border-radius: 0 !important;
    bottom: 0 !important;
    top: 0 !important;
    left: 40px !important;
    right: 0 !important;
    width: 90% !important;
    max-width: inherit !important;
    min-width: inherit !important;
    position: fixed;
    height: 100%;
    margin: 0 !important;
  }
}

.date-time-picker {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.date-time-picker,
.date-time-picker input,
.date-time-picker label,
.date-time-picker p,
.date-time-picker span {
  font-family: Roboto, -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
}

.date-time-picker .fluid {
  width: 100%;
}

.date-time-picker .fill-height {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 100%;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 100%;
  flex: 1 1 100%;
}

.date-time-picker .spacer {
  -webkit-box-flex: 1 !important;
  -ms-flex-positive: 1 !important;
  flex-grow: 1 !important;
}

.date-time-picker .align-center {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.date-time-picker .flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.date-time-picker .flex-start {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  justify-content: flex-start;
  -ms-flex-pack: start;
  -moz-box-align: start;
  -moz-box-pack: start;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
}

.date-time-picker .flex-end {
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
  justify-content: flex-end;
  -ms-flex-pack: end;
  -moz-box-align: end;
  -moz-box-pack: end;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
}

.date-time-picker .flex-direction-column {
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -ms-flex-flow: column;
  flex-flow: column;
  -moz-flex-direction: column;
}

.date-time-picker .flex-direction-column-reverse {
  -ms-flex-direction: column-reverse;
  -webkit-box-orient: vertical;
  -webkit-box-direction: reverse;
  flex-direction: column-reverse;
  -ms-flex-flow: column-reverse;
  flex-flow: column-reverse;
  -moz-flex-direction: column-reverse;
}

.date-time-picker .flex-direction-row {
  -ms-flex-direction: row;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
  -ms-flex-flow: row;
  flex-flow: row;
  -moz-flex-direction: row;
}

.date-time-picker .justify-content-end,
.date-time-picker .justify-content-right {
  justify-content: flex-end;
  -ms-flex-pack: end;
  -moz-box-align: end;
  -moz-box-pack: end;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -webkit-box-align: end;
}

.date-time-picker .justify-content-center {
  justify-content: center;
  -ms-flex-pack: center;
  -moz-box-align: center;
  -moz-box-pack: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -webkit-box-align: center;
}

.date-time-picker .justify-content-between {
  justify-content: space-between;
}

.date-time-picker .justify-content-around,
.date-time-picker .justify-content-between {
  -ms-flex-pack: justify;
  -moz-box-align: stretch;
  -moz-box-pack: justify;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -webkit-box-align: stretch;
}

.date-time-picker .justify-content-around {
  justify-content: space-around;
}

.date-time-picker .flex-fill {
  -moz-flex: 0 1 auto;
  -ms-flex: 0 1 auto;
  -webkit-box-flex: 0;
  flex: 0 1 auto;
}

.date-time-picker .flex-fixed {
  -moz-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  -webkit-box-flex: 0;
  flex: 0 0 auto;
}

.date-time-picker .flex-1 {
  -webkit-box-flex: 1;
  -moz-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.date-time-picker .flex-wrap {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.date-time-picker .flex-grow {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

.date-time-picker .lm-fs-12 {
  font-size: 12px !important;
}

.date-time-picker .lm-fs-14 {
  font-size: 14px !important;
}

.date-time-picker .lm-fs-16 {
  font-size: 16px !important;
}

.date-time-picker .lm-fs-18 {
  font-size: 18px !important;
}

.date-time-picker .lm-fw-300 {
  font-weight: 300;
}

.date-time-picker .lm-fw-400 {
  font-weight: 400;
}

.date-time-picker .lm-fw-500 {
  font-weight: 500;
}

.date-time-picker .container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .date-time-picker .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .date-time-picker .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .date-time-picker .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .date-time-picker .container {
    max-width: 1140px;
  }
}

.date-time-picker .lm-pr-1 {
  padding-right: 0.25rem !important;
}

.date-time-picker .lm-pt-1 {
  padding-top: 0.25rem !important;
}

.date-time-picker .lm-pb-1 {
  padding-bottom: 0.25rem !important;
}

.date-time-picker .lm-pl-1,
.date-time-picker .lm-px-1 {
  padding-left: 0.25rem !important;
}

.date-time-picker .lm-px-1 {
  padding-right: 0.25rem !important;
}

.date-time-picker .lm-py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.date-time-picker .lm-p-1 {
  padding: 0.25rem !important;
}

.date-time-picker .lm-pr-2 {
  padding-right: 0.5rem !important;
}

.date-time-picker .lm-pt-2 {
  padding-top: 0.5rem !important;
}

.date-time-picker .lm-pb-2 {
  padding-bottom: 0.5rem !important;
}

.date-time-picker .lm-pl-2,
.date-time-picker .lm-px-2 {
  padding-left: 0.5rem !important;
}

.date-time-picker .lm-px-2 {
  padding-right: 0.5rem !important;
}

.date-time-picker .lm-py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.date-time-picker .lm-p-2 {
  padding: 0.5rem !important;
}

.date-time-picker .lm-pr-3 {
  padding-right: 1rem !important;
}

.date-time-picker .lm-pt-3 {
  padding-top: 1rem !important;
}

.date-time-picker .lm-pb-3 {
  padding-bottom: 1rem !important;
}

.date-time-picker .lm-pl-3,
.date-time-picker .lm-px-3 {
  padding-left: 1rem !important;
}

.date-time-picker .lm-px-3 {
  padding-right: 1rem !important;
}

.date-time-picker .lm-py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.date-time-picker .lm-p-3 {
  padding: 1rem !important;
}

.date-time-picker .lm-pr-4 {
  padding-right: 1.5rem !important;
}

.date-time-picker .lm-pt-4 {
  padding-top: 1.5rem !important;
}

.date-time-picker .lm-pb-4 {
  padding-bottom: 1.5rem !important;
}

.date-time-picker .lm-pl-4,
.date-time-picker .lm-px-4 {
  padding-left: 1.5rem !important;
}

.date-time-picker .lm-px-4 {
  padding-right: 1.5rem !important;
}

.date-time-picker .lm-py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.date-time-picker .lm-p-4 {
  padding: 1.5rem !important;
}

.date-time-picker .lm-pr-5 {
  padding-right: 3rem !important;
}

.date-time-picker .lm-pt-5 {
  padding-top: 3rem !important;
}

.date-time-picker .lm-pb-5 {
  padding-bottom: 3rem !important;
}

.date-time-picker .lm-pl-5,
.date-time-picker .lm-px-5 {
  padding-left: 3rem !important;
}

.date-time-picker .lm-px-5 {
  padding-right: 3rem !important;
}

.date-time-picker .lm-py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.date-time-picker .lm-p-5 {
  padding: 3rem !important;
}

.date-time-picker .lm-mr-1 {
  margin-right: 0.25rem !important;
}

.date-time-picker .lm-mt-1 {
  margin-top: 0.25rem !important;
}

.date-time-picker .lm-mb-1 {
  margin-bottom: 0.25rem !important;
}

.date-time-picker .lm-ml-1,
.date-time-picker .lm-mx-1 {
  margin-left: 0.25rem !important;
}

.date-time-picker .lm-mx-1 {
  margin-right: 0.25rem !important;
}

.date-time-picker .lm-my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.date-time-picker .lm-m-1 {
  margin: 0.25rem !important;
}

.date-time-picker .lm-mr-2 {
  margin-right: 0.5rem !important;
}

.date-time-picker .lm-mt-2 {
  margin-top: 0.5rem !important;
}

.date-time-picker .lm-mb-2 {
  margin-bottom: 0.5rem !important;
}

.date-time-picker .lm-ml-2,
.date-time-picker .lm-mx-2 {
  margin-left: 0.5rem !important;
}

.date-time-picker .lm-mx-2 {
  margin-right: 0.5rem !important;
}

.date-time-picker .lm-my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.date-time-picker .lm-m-2 {
  margin: 0.5rem !important;
}

.date-time-picker .lm-mr-3 {
  margin-right: 1rem !important;
}

.date-time-picker .lm-mt-3 {
  margin-top: 1rem !important;
}

.date-time-picker .lm-mb-3 {
  margin-bottom: 1rem !important;
}

.date-time-picker .lm-ml-3 {
  margin-left: 1rem !important;
}

.date-time-picker .lm-mx-3 {
  margin-left: 1rem !important;
  margin-right: 1rem !important;
}

.date-time-picker .lm-my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.date-time-picker .lm-m-3 {
  margin: 1rem !important;
}

.date-time-picker .lm-mr-4 {
  margin-right: 1.5rem !important;
}

.date-time-picker .lm-mt-4 {
  margin-top: 1.5rem !important;
}

.date-time-picker .lm-mb-4 {
  margin-bottom: 1.5rem !important;
}

.date-time-picker .lm-ml-4,
.date-time-picker .lm-mx-4 {
  margin-left: 1.5rem !important;
}

.date-time-picker .lm-mx-4 {
  margin-right: 1.5rem !important;
}

.date-time-picker .lm-my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.date-time-picker .lm-m-4 {
  margin: 1.5rem !important;
}

.date-time-picker .lm-mr-5 {
  margin-right: 3rem !important;
}

.date-time-picker .lm-mt-5 {
  margin-top: 3rem !important;
}

.date-time-picker .lm-mb-5 {
  margin-bottom: 3rem !important;
}

.date-time-picker .lm-ml-5 {
  margin-left: 3rem !important;
}

.date-time-picker .lm-mx-5 {
  margin-left: 3rem !important;
  margin-right: 3rem !important;
}

.date-time-picker .lm-my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.date-time-picker .lm-m-5 {
  margin: 3rem !important;
}

.date-time-picker .lm-btn {
  padding: 10px 20px;
  margin-bottom: 20px;
  border: none;
  display: inline-block;
  border-radius: 4px;
  text-decoration: none;
  font-size: 12px;
  outline: none;
  cursor: pointer;
  -webkit-transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  background-color: #1e90ff;
  color: #fff;
  font-weight: 500;
}

.date-time-picker .lm-btn:hover {
  background-color: #0077ea;
  -webkit-box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
    0 2px 4px 0 rgba(232, 237, 250, 0.5);
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
    0 2px 4px 0 rgba(232, 237, 250, 0.5);
}

.date-time-picker .lm-btn.option {
  background-color: #424242;
}

.date-time-picker .lm-btn.option:hover {
  background-color: #292929;
}

.date-time-picker .lm-btn-success {
  background-color: #9acd32;
}

.date-time-picker .lm-btn-success:hover {
  background-color: #7ba428;
}

.date-time-picker .lm-btn-dark {
  background-color: #424242;
}

.date-time-picker .lm-btn-dark:hover {
  background-color: #292929;
}

.date-time-picker .lm-btn-danger {
  background-color: #ff4500;
}

.date-time-picker .lm-btn-danger:hover {
  background-color: #cc3700;
}

.date-time-picker .dark .lm-btn:hover {
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.6),
    0 2px 4px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.6), 0 2px 4px 0 rgba(0, 0, 0, 0.5);
}

.date-time-picker .dark .lm-btn.option {
  background-color: #424242;
}

.date-time-picker .dark .lm-btn.option:hover {
  background-color: #5c5c5c;
}

.date-time-picker .slide-enter-active,
.date-time-picker .slide-leave-active {
  opacity: 1;
  z-index: 998;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  -webkit-transform: translateY(0);
  transform: translateY(0);
}

.date-time-picker .slide-enter,
.date-time-picker .slide-leave-to {
  opacity: 0;
  z-index: 998;
  -webkit-transform: translateY(-20px);
  transform: translateY(-20px);
}

.date-time-picker .slideinvert-enter-active,
.date-time-picker .slideinvert-leave-active {
  opacity: 1;
  z-index: 998;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  -webkit-transform: translateY(0);
  transform: translateY(0);
}

.date-time-picker .slideinvert-enter,
.date-time-picker .slideinvert-leave-to {
  opacity: 0;
  z-index: 998;
  -webkit-transform: translateY(40px);
  transform: translateY(40px);
}

.date-time-picker .slidenext-enter-active,
.date-time-picker .slidenext-leave-active,
.date-time-picker .slideprev-enter-active,
.date-time-picker .slideprev-leave-active {
  position: absolute;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.date-time-picker .slidenext-enter,
.date-time-picker .slideprev-leave-to {
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
}

.date-time-picker .slidenext-leave-to,
.date-time-picker .slideprev-enter {
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
}

.date-time-picker .slidevnext-enter-active,
.date-time-picker .slidevnext-leave-active,
.date-time-picker .slidevprev-enter-active,
.date-time-picker .slidevprev-leave-active {
  position: absolute;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.date-time-picker .slidevnext-enter,
.date-time-picker .slidevprev-leave-to {
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  opacity: 0;
}

.date-time-picker .slidevnext-leave-to,
.date-time-picker .slidevprev-enter {
  -webkit-transform: translateY(-100%);
  transform: translateY(-100%);
  opacity: 0;
}

@media screen and (max-width: 415px) {
  .date-time-picker .slide-enter-active,
  .date-time-picker .slide-leave-active,
  .date-time-picker .slideinvert-enter-active,
  .date-time-picker .slideinvert-leave-active {
    -webkit-transition: all 0s;
    transition: all 0s;
  }
}

.date-time-picker .lm-text-white {
  color: #fff;
}

.date-time-picker .lm-dots-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.date-time-picker .lm-text-muted {
  color: rgba(0, 0, 0, 0.54) !important;
}

.date-time-picker .lm-text-strong {
  font-weight: 500;
}

.date-time-picker .lm-text-center {
  text-align: center !important;
}

.date-time-picker .lm-text-left {
  text-align: left !important;
}

.date-time-picker .lm-text-right {
  text-align: right !important;
}

.date-time-picker .lm-h-100 {
  height: 100% !important;
}

.date-time-picker .lm-mh-100 {
  max-height: 100% !important;
}

.date-time-picker .lm-w-100 {
  width: 100% !important;
}

.date-time-picker .lm-mw-100 {
  max-width: 100% !important;
}

.date-time-picker *,
.date-time-picker :after,
.date-time-picker :before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.date-time-picker {
  width: 100%;
  margin: 0 auto;
  text-align: left;
  font-size: 14px;
  border-radius: 4px;
  position: relative;
}

.date-time-picker .time-picker-overlay {
  z-index: 2;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
}

@media screen and (max-width: 415px) {
  .time-picker-overlay {
    display: none;
  }
  .date-time-picker:not(.inline) {
    position: inherit !important;
  }
  .modal-body {
    min-height: 350px;
    overflow-y: auto;
  }
}
/**datepicker */
.modal-body {
  min-height: 350px;
  overflow-y: auto;
}
.modal-mobile {
  position: fixed;
  top: 0;
  right: -17px;
  bottom: 0;
  left: 36px;
  z-index: 1050;
  display: none;
  overflow: hidden;
  outline: 0;
}
.cursor-pointer {
  cursor: pointer;
}
.v-select .v-select-bar {
  position: relative;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  white-space: nowrap;
  margin-bottom: calc(0px - var(--padd));
  padding-left: 7px;
  width: 100%;
}
.v-select {
  position: relative;
  outline: none;
  border: 1px solid #e3e3e3;
  border-radius: 30px;
}
.v-select {
  word-spacing: normal;
  text-transform: none;
  text-indent: 0px;
  text-shadow: none;
  font: 400 12px system-ui;
}
.v-select .v-select-option {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.3em 0.5em;
  cursor: pointer;
  margin-right: 34px;
  border-radius: 30px;
}
.v-select .v-select-selected:first-of-type {
  padding-left: 14px;
}
</style>



// WEBPACK FOOTER //
// src/app/tenant/profile/me/schedule.vue